module.exports = (__webpack_require__(8))(4);


//////////////////
// WEBPACK FOOTER
// delegated ./clients/web/src/rest.js from dll-reference girder_lib
// module id = 349
// module chunks = 0